import React from 'react';
import { Link } from 'gatsby';

import Hero from './Hero';
import MarkdownRenderer from './MarkdownRenderer';
import Pill from './Pill';
import RelatedContent from './RelatedContent';
import ShareSheet from './ShareSheet';
import Section from './Section';
import ContentWithTOC from './ContentWithTOC';

const ContentPage = ({ page, location, relatedContent, type }) => {
  if (!page) return null;
  const pagesWithTOC = [
    'GraphCMS_AcademyPost',
    'GraphCMS_CaseStudy',
  ];
  return (
    <React.Fragment>
      <Section>
        <Hero {...page}>
          {type === 'blog' && (
            <div className="-mx-1 -my-1 flex flex-wrap items-center justify-center">
              {page.categories.map(({ shortTitle, slug }, index) => (
                <Link to={`/blog/tag/${slug}`} key={index}>
                  <Pill label={shortTitle} size="large" />
                </Link>
              ))}
            </div>
          )}
        </Hero>

        {pagesWithTOC.includes(page['__typename']) ? (
          <ContentWithTOC page={page} togglerRequired={false}>
            <MarkdownRenderer {...page} />
          </ContentWithTOC>
        ) : (
          <div className="max-w-3xl mx-auto h-auto">
            <MarkdownRenderer {...page} />
          </div>
        )}

        <div className="flex items-center justify-between mt-6 md:-mr-3">
          <hr className="md:block bg-cornflower border-0 h-1 my-6 md:my-12 rounded w-24 md:w-48" />
          <ShareSheet title={page.title} url={location.href} />
        </div>
      </Section>

      <RelatedContent relatedContent={relatedContent} />
    </React.Fragment>
  );
};

export default ContentPage;
